module.exports = __webpack_public_path__ + "fonts/SFUIText-Medium.347bf90c.eot";